import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.connectorDefinition.DOC}
  mutation CreateIntegrationConnectorDefinition(
    $tenantId: ID!
    $zoneId: ID!
    $input: IntgConnectorDefinitionInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        createIntgConnectorDefinition(input: $input) {
          ...FragmentIntegrationConnectorDefinition
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.CreateIntegrationConnectorDefinitionMutation,
    ents.core.integrations.Connector.Definition,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'createIntgConnectorDefinition',
        fragments.connectorDefinition.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.CreateIntegrationConnectorDefinitionMutation,
  ents.core.integrations.Connector.Definition,
  graphql.schema.CreateIntegrationConnectorDefinitionMutationVariables
>({ query: DOC, transformer: TRANSFORMER })
